module.exports = __webpack_public_path__ + "static/media/St Mand 2011.6e29723e.jpg";